import { Box, Typography } from '@mui/material';

interface SectionHeaderProps {
  title: string;
  helper?: string;
}

export function SectionHeader({ title, helper }: SectionHeaderProps) {
  return (
    <Box>
      <Typography
        variant="subtitle2"
        sx={{
          fontWeight: 'medium',
          color: 'text.secondary',
        }}
      >
        {title}
      </Typography>
      {helper && (
        <Typography
          variant="caption"
          sx={{
            color: 'text.disabled',
          }}
        >
          {helper}
        </Typography>
      )}
    </Box>
  );
}
